import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useQuery } from "react-query"
import { getCertification } from "~/actions/certifications"
import analyticsColor from "~/assets/Icons/colored-pie-chart.svg"
import contentColor from "~/assets/Icons/colored-video.svg"
import analytics from "~/assets/Icons/feather-pie-chart.svg"
import content from "~/assets/Icons/feather-video.svg"
import seoColor from "~/assets/Icons/seo-colored-icon.svg"
import seo from "~/assets/Icons/seo-icon.svg"
import CertificationHeader from "~/components/Certifications/CertificationHeader"
import ContentTabs from "~/components/Common/ContentTabs"
import { CertificationContainer } from "~/contexts/Certification"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"

const Certification = ({ routes = [], ...rest }) => {
  const certificationId = +rest?.match?.params?.certification_id

  const { data: certification, isLoading: certificationLoading } = useQuery(
    ["certification", certificationId],
    () => getCertification(certificationId),
    {
      cacheTime: 0,
    },
  )

  const tabs = [
    {
      label: "Certification Content",
      link: `/certifications/${certificationId}/content`,
      icon1: content,
      icon2: contentColor,
    },
    {
      label: "Seo",
      link: `/certifications/${certificationId}/seo`,
      icon1: seo,
      icon2: seoColor,
    },
    {
      label: "Analytics",
      link: `/certifications/${certificationId}/analytics`,
      icon1: analytics,
      icon2: analyticsColor,
    },
  ]

  if (!certification?.id) {
    return <LinearProgress color="primary" />
  }

  return (
    <Page>
      <CertificationContainer certification={certification}>
        <Box display="flex" flexDirection="column" height="100%">
          <Box flexShrink={0} flexGrow={0}>
            <CertificationHeader />
            <ContentTabs tabs={tabs} />
          </Box>
          <Box flexGrow={1} overflow="auto">
            <Router routes={routes} {...rest} />
          </Box>
        </Box>
      </CertificationContainer>
    </Page>
  )
}

Certification.propTypes = {
  routes: PropTypes.array,
}

export default Certification
